<div>
  <span style="width:84px;display:inline-block;">Reinvestment:</span>

  @if (!isShowReinvestmentDividendsVarious) {
    <input [disabled]="pfs?.updateOrderPayload?.disableMode" [checked]="reinvestmentDividends"
      type="checkbox" (change)="reinvestmentDividendsChanged($event)" />
  }
  @if (isShowReinvestmentDividendsVarious) {
    <img src="/assets/images/checkboxIndeterminate.svg" class="checkbox-indeterminate"
      (click)="dividendsVariousClicked()">
    } Reinvest Dividends

    @if (!isShowReinvestmentCapitalGainsVarious) {
      <input [disabled]="pfs?.updateOrderPayload?.disableMode" [checked]="reinvestmentCapitalGains"
        type="checkbox" (change)="reinvestmentCapitalGainsChanged($event)" />
    }
    @if (isShowReinvestmentCapitalGainsVarious) {
      <img src="/assets/images/checkboxIndeterminate.svg" class="checkbox-indeterminate"
        (click)="capitalGainsVariousClicked()">
      } Reinvest Capital Gains
    </div>
    <div style="height:10px;"></div>
    <div>
      <span style="width:88px;display:inline-block;">Fees:
        @if (sharesPresent) {
          <span class="tooltipIconLeft infoIcon suggested-name"
            style="display:inline-block;" calltoaction
          [calltoactionTemplate]="feesOptionToolTipIcon"></span>
        }
      </span>
      <irb-dropdown-filter #feeElem (search)="getFee($event)"
        [disabled]="pfs?.updateOrderPayload?.disableMode || sharesPresent || !isAllMutualFund"
        [placeholder]="isFeeVarious ? 'Various': ''"
        [(value)]="feeSelected"
        size="16" hoverPanelWidth="155"
      (selection)="feesOptionChanged()"></irb-dropdown-filter>

    </div>
    <ng-template #feesOptionToolTipIcon >
      <div>
        Fee options are not editable: <br>
        some orders have amount type "Shares"<br>
      </div>
    </ng-template>

    <ng-template #reinvestUnsupportedConfigMessage>
      <div class="block"><strong>Unsupported:</strong><br/>
    Dividends Yes, Capital Gains No</div>
    <div><strong>Supported:</strong><br/>
    Dividends Yes, Capital Gains Yes<br/>
    Dividends No, Capital Gains Yes<br/>
  Dividends No, Capital Gains No</div>
</ng-template>